import Link from 'next/link';
import { FC, memo, ReactNode } from 'react';

interface NavSubLink {
  id: number;
  href: string;
  name: string;
  defaultName?: string;
  subName?: string;
  defaultSubName?: string;
  menuIcon?: ReactNode;
  external?: boolean;
}

interface NavItem {
  id: number;
  dropId: number;
  name: string;
  href: string;
  icon?: ReactNode | '';
  active?: boolean;
  target?: string;
  rel?: string;
  isGradient?: boolean;
  links?: NavSubLink[];
}
type NavOuterLinkProps = {
  item: NavItem;
  children: ReactNode;
};

const NavOuterLink = ({ item, children }: NavOuterLinkProps) => {
  if (item.target) {
    return (
      <a href={item.href} target={item.target} rel={item.rel}>
        {children}
      </a>
    );
  }
  return <Link href={item.href}>{children}</Link>;
};

export default memo(NavOuterLink);
